/* Fits cards 3D spin. Sprite = 24 frames side by side (background-size 2400% 100%), same camera and crop.
   - Sprite is only requested once its card is within ~400px of the viewport.
   - Mouse: hovering the card spins front -> rear over ~0.9s (eased, frame stepped); leaving reverses it.
   - Touch (hover:none): tapping the card toggles front/rear.
   - prefers-reduced-motion: no spin at all, rest (front) frame only. */
(function () {
  'use strict';
  var N = 24, DUR = 900;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touchOnly = window.matchMedia && matchMedia('(hover: none)').matches;
  var cars = [].slice.call(document.querySelectorAll('[data-fit-car]'));
  if (!cars.length) return;
  function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
  function setup(car) {
    var card = car.closest('[data-fit-card]'), pos = 0, target = 0, from = 0, t0 = 0, raf = 0, shown = -1;
    function paint(p) {
      var f = Math.round(p * (N - 1));
      if (f !== shown) { shown = f; car.style.backgroundPosition = (f / (N - 1) * 100) + '% 0'; }
    }
    function tick(now) {
      var k = Math.min(1, (now - t0) / (DUR * Math.max(0.25, Math.abs(target - from))));
      pos = from + (target - from) * ease(k); paint(pos);
      raf = k < 1 ? requestAnimationFrame(tick) : 0;
    }
    function go(to) {
      if (reduce || to === target) return;
      target = to; from = pos; t0 = performance.now();
      if (!raf) raf = requestAnimationFrame(tick);
    }
    if (!reduce) {
      if (touchOnly) { card.addEventListener('click', function () { go(target ? 0 : 1); }); }
      else {
        card.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'touch') go(1); });
        card.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'touch') go(0); });
      }
    }
    var img = new Image();
    img.onload = function () { car.style.backgroundImage = 'url("' + car.getAttribute('data-src') + '")'; car.classList.add('is-ready'); };
    return function load() { img.src = car.getAttribute('data-src'); };
  }
  var loaders = cars.map(setup);
  if (!('IntersectionObserver' in window)) { loaders.forEach(function (l) { l(); }); return; }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { loaders[cars.indexOf(e.target)](); io.unobserve(e.target); } });
  }, { rootMargin: '400px 0px' });
  cars.forEach(function (c) { io.observe(c); });
})();
